import { Text } from "appworks/graphics/pixi/text";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { pulse, scaleIn, scaleOut } from "appworks/utils/animation/scale";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Sequence } from "appworks/utils/contracts/sequence";
import { Timer } from "appworks/utils/timer";
import { Easing } from "appworks/utils/tween";
import { gameLayers } from "game-layers";
import { SlingoSoundEvent } from "slingo/sound/slingo-sound-events";
import { SlingoFullHouseState } from "slingo/states/slingo-full-house-state";
import { ApplyFowlPlayTextStyling } from "util/fowl-text-style";

export class FowlFullHouseState extends SlingoFullHouseState {
    protected showFullHouseAnimation(): Contract<void> {
        const layer = gameLayers.CelebrationContent;
        let text: Text;

        return new Sequence([
            () =>
                new Parallel([
                    () =>
                        Contract.wrap(() => {
                            Services.get(SoundService).event((SlingoSoundEvent as any).slingo_animate_line_N, "0");
                            Timer.setTimeout(() => Services.get(SoundService).event((SlingoSoundEvent as any).slingo_animate_line_N, "1"), 750);
                        }),
                    () => super.showFullHouseAnimation(),
                    () =>
                        Contract.getDelayedContract(
                            1500,
                            () =>
                                new Parallel([
                                    () => gameLayers.CelebrationContent.setScene("fullhouse"),
                                    () => gameLayers.CelebrationBackground.setScene("fullhouse"),
                                    () =>
                                        Contract.wrap(() => {
                                            text = layer.getText("fullhouse");

                                            ApplyFowlPlayTextStyling(text, 4);
                                            text.landscape.scale.set(0);
                                            text.portrait.scale.set(0);
                                        }),
                                    () =>
                                        new Sequence([
                                            () => scaleIn(text, 750, Easing.Back.Out),
                                            () => pulse(text, { x: 0.85, y: 0.85 }, 500, Easing.Sinusoidal.Out),
                                            () => pulse(text, { x: 0.85, y: 0.85 }, 500, Easing.Sinusoidal.Out),
                                            () => pulse(text, { x: 0.85, y: 0.85 }, 500, Easing.Sinusoidal.Out),
                                            () => pulse(text, { x: 0.85, y: 0.85 }, 500, Easing.Sinusoidal.Out),
                                            () => pulse(text, { x: 0.85, y: 0.85 }, 500, Easing.Sinusoidal.Out),
                                            () => pulse(text, { x: 0.85, y: 0.85 }, 500, Easing.Sinusoidal.Out),
                                        ]),
                                ])
                        ),
                ]),
            () => new Parallel([() => scaleOut(text, 300, Easing.Cubic.In), () => gameLayers.CelebrationBackground.defaultScene()]),
            () => gameLayers.CelebrationContent.defaultScene(),
        ]);
    }
}
